import { render } from "./orderDetail.vue?vue&type=template&id=017ca7f6&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=js"
export * from "./orderDetail.vue?vue&type=script&lang=js"

import "./orderDetail.vue?vue&type=style&index=0&id=017ca7f6&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "/home/pages/train-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017ca7f6"],['__file',"src/views/my/orderDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "017ca7f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('017ca7f6', __exports__)) {
    console.log('reload')
    api.reload('017ca7f6', __exports__)
  }
  
  module.hot.accept("./orderDetail.vue?vue&type=template&id=017ca7f6&scoped=true", () => {
    console.log('re-render')
    api.rerender('017ca7f6', render)
  })

}


export default __exports__